var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.104065,
    width: 26.7918,
    height: 26.7918,
    rx: 13.3959,
    fill: "#FFF1F1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.3959,
    cy: 13.3959,
    r: 13.3959,
    fill: "#FFF1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65236 19.4615H17.3476C18.2591 19.4615 19 18.7206 19 17.8091V9.57529C19 8.6638 18.2591 7.92293 17.3476 7.92293H16.6922V7.46146C16.6922 7.20761 16.4846 7 16.2307 7C15.9769 7 15.7693 7.20761 15.7693 7.46146V7.92293H10.231V7.46146C10.231 7.20761 10.0234 7 9.76951 7C9.51566 7 9.30805 7.20761 9.30805 7.46146V7.92293H8.6526C7.74087 7.92317 7 8.6638 7 9.57529V17.8091C7 18.7206 7.74087 19.4615 8.65236 19.4615ZM7.92317 9.57529C7.92317 9.1737 8.25077 8.8461 8.65236 8.8461H9.3078V9.30756C9.3078 9.56141 9.51541 9.76902 9.76927 9.76902C10.0231 9.76902 10.2307 9.56141 10.2307 9.30756V8.8461H15.7693V9.30756C15.7693 9.56141 15.9769 9.76902 16.2307 9.76902C16.4846 9.76902 16.6922 9.56141 16.6922 9.30756V8.8461H17.3476C17.7492 8.8461 18.0768 9.1737 18.0768 9.57529V10.9229H7.92317V9.57529ZM7.92317 11.8461H18.0771V17.8091C18.0771 18.2107 17.7495 18.5383 17.3479 18.5383H8.65236C8.25077 18.5383 7.92317 18.2107 7.92317 17.8091V11.8461Z",
    fill: "#FD8D75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.f5ea2b31a62a9ea6bba3415f980bd246.svg";
export { ForwardRef as ReactComponent };